import { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useSession } from "@/lib/auth-client";
import Nav from "@/components/Nav";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Fudges from "./pages/Fudges";
import FudgeHistory from "./pages/FudgeHistory";
import Users from "./pages/Users";
import Database from "./pages/admin/Database";
import Tags from "./pages/admin/Tags";
import Events from "./pages/admin/Events";
import KksCodes from "./pages/admin/KksCodes";
import Peers from "./pages/Peers";
import Scan from "./pages/Scan";
import ReapplyWaiting from "./pages/ReapplyWaiting";
import ScanTag from "./pages/ScanTag";
import CheckTag from "./pages/CheckTag";

function ProtectedLayout() {
  const { data: session, isPending } = useSession();
  const [navOpen, setNavOpen] = useState(false);

  if (isPending) {
    return (
      <div className="h-full flex items-center justify-center bg-slate-50">
        <p className="text-sm text-slate-400">Loading…</p>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex flex-col h-full md:flex-row">
      <div className="md:hidden flex items-center h-12 px-4 bg-slate-800 flex-shrink-0">
        <button
          onClick={() => setNavOpen(true)}
          className="text-slate-300 hover:text-white p-2 -ml-2"
          aria-label="Open navigation"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
        <img src="/logo.jpg" alt="Logo" className="ml-3 w-6 h-6 rounded object-cover" />
        <span className="ml-2 text-sm font-semibold text-slate-200">Fudge Log</span>
      </div>
      <Nav open={navOpen} onClose={() => setNavOpen(false)} />
      <main className="flex-1 overflow-y-auto bg-slate-50">
        <Outlet />
      </main>
    </div>
  );
}

function AdminRoute() {
  const { data: session } = useSession();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((session?.user as any)?.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/scan/:id" element={<Scan />} />
        <Route element={<ProtectedLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/fudges" element={<Fudges />} />
          <Route path="/fudges/history" element={<FudgeHistory />} />
          <Route path="/fudges/reapply" element={<ReapplyWaiting />} />
          <Route path="/scan-tag" element={<ScanTag />} />
          <Route path="/check-tag" element={<CheckTag />} />
          <Route element={<AdminRoute />}>
            <Route path="/users" element={<Users />} />
            <Route path="/admin/database" element={<Database />} />
            <Route path="/admin/tags" element={<Tags />} />
            <Route path="/admin/events" element={<Events />} />
            <Route path="/admin/kks-codes" element={<KksCodes />} />
            <Route path="/peers" element={<Peers />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
